/**
 * 無限スクロール機能を実装するためのスクリプト
 * 商品一覧ページで、ユーザーがページ下部に到達した際に自動的に次のページを読み込む
 */

document.addEventListener('DOMContentLoaded', function () {
  // data-autopagerize属性を持つ要素を取得
  const autopagerizeElement = document.querySelector(
    '[data-autopagerize="true"]'
  );
  if (!autopagerizeElement) return;

  // data-base-url属性を取得
  const dataBaseUrl = autopagerizeElement.dataset.baseUrl;

  // ページネーション要素を取得する関数
  const getPagination = () => {
    const pagination = autopagerizeElement.nextElementSibling;
    return pagination?.classList.contains('pagination') ? pagination : null;
  };

  // 現在のページ番号を取得する関数
  const getCurrentPage = () => {
    const activeLi = getPagination()?.querySelector('li.active');
    if (!activeLi) return 1;
    return parseInt(activeLi.textContent.trim()) || 1;
  };

  // 現在のURLからフィルターパスを取得する関数
  const getFilterPath = () => {
    const url = new URL(window.location.href);
    const pathSegments = url.pathname.split('/');
    const filterSegments = pathSegments.filter(segment =>
      segment.startsWith('filter-')
    );
    return filterSegments.join('/');
  };

  const hasNextPage = () => {
    const activeLi = getPagination()?.querySelector('li.active');
    if (!activeLi) return false;
    return activeLi.nextElementSibling?.querySelector('a')?.getAttribute('href')
      ? true
      : false;
  };

  // 売り切れ商品を末尾に寄せるための処理・関数

  // アイテムが売り切れか調べる関数
  const isSoldOut = product => {
    const soldOutBadge = product.querySelector('.product-item__badge--sold');
    return soldOutBadge ? true : false;
  };

  // アイテムがpinnedタグを持っているか調べる関数
  const isPinned = product => {
    return product.dataset.pinned === 'true';
  };

  // アイテムを末尾に移動すべきか判定する関数
  // 売り切れかつpinnedでない商品のみtrueを返す
  const shouldMoveToEnd = product => {
    return isSoldOut(product) && !isPinned(product);
  };

  // 最初に表示された商品からSoldoutの商品を取り除き、変数にキャッシュする
  // ただし、pinnedタグがある商品は位置をキープする
  const initialProducts = document.querySelectorAll('.product-item');
  let unavailableProducts = Array.from(initialProducts).filter(product => {
    return shouldMoveToEnd(product);
  });

  // 変数にキャッシュした商品を表示から削除
  unavailableProducts.forEach(product => {
    product.remove();
  });

  // 売り切れ商品を変数にキャッシュする関数
  const pushUnavailableProducts = product => {
    unavailableProducts.push(product);
  };

  // 売り切れ商品を表示する関数
  const showUnavailableProducts = () => {
    if (unavailableProducts.length > 0) {
      unavailableProducts.forEach(product => {
        autopagerizeElement.insertAdjacentHTML('beforeend', product.outerHTML);
      });
      unavailableProducts = [];
    }
  };

  // GAのページビューを送信する関数
  const sendGAPageView = pageNumber => {
    const newUrl = `${window.location.pathname}?page=${pageNumber}`;
    // URLを更新
    // history.pushState({ page: pageNumber }, "", newUrl);
    const pageInfo = {
      page_title: document.title,
      page_location: `${window.location.origin}${newUrl}`,
      page_path: newUrl,
    };
    // console.log("sendGAPageView", pageInfo);
    if (typeof gtag === 'function') {
      gtag('event', 'page_view', pageInfo);
    }
  };

  // IntersectionObserverの設定
  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        const pagination = getPagination();
        if (!pagination) return;

        if (entry.target === pagination && entry.isIntersecting) {
          const activeLi = pagination.querySelector('li.active');
          const nextPageLink = activeLi?.nextElementSibling?.querySelector('a');

          if (nextPageLink) {
            const currentPage = getCurrentPage();
            const nextPage = currentPage + 1;
            const nextPageUrl = `${dataBaseUrl}?page=${nextPage}`;
            loadNextPage(nextPageUrl, entry.target, nextPage);
          }
        }
      });
    },
    {
      rootMargin: '0px 0px 600px 0px',
      threshold: 0,
    }
  );

  /**
   * 次のページの商品を読み込む関数
   * @param {string} url - 読み込むページのURL
   * @param {HTMLElement} pagination - 商品グリッドを挿入する要素
   * @param {number} pageNumber - 読み込むページ番号
   */
  function loadNextPage(url, pagination, pageNumber) {
    // 既存のページネーションを削除
    observer.unobserve(pagination);
    pagination.remove();

    // フィルターパスを取得
    const filterPath = getFilterPath();
    const baseUrl = url.split('?')[0]; // クエリパラメータを除去
    const nextPageUrl = `${baseUrl}/${filterPath}?page=${pageNumber}`;

    fetch(nextPageUrl)
      .then(response => response.text())
      .then(html => {
        // GAのページビューを送信
        sendGAPageView(pageNumber);

        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // 商品グリッドを探す
        const newProducts = doc.querySelector('#main-collection-product-grid');
        if (!newProducts) return;

        // 新しい商品を追加
        const products = newProducts.querySelectorAll('.product-item');

        let addedProductsCount = 0;
        products.forEach(product => {
          if (shouldMoveToEnd(product)) {
            // 売り切れかつpinnedでない商品を末尾に寄せる
            pushUnavailableProducts(product);
          } else {
            addedProductsCount++;
            autopagerizeElement.insertAdjacentHTML(
              'beforeend',
              product.outerHTML
            );
          }
        });

        // 追加できる商品がない場合、売り切れ商品を表示する
        if (addedProductsCount === 0) {
          showUnavailableProducts();
        }

        // LazyLoadの再実行
        window.preloadImages(autopagerizeElement);

        // ページネーションを探す
        const newPagination = doc.querySelector('.pagination');
        if (!newPagination) return;

        // 新しいページネーションを追加
        autopagerizeElement.insertAdjacentHTML(
          'afterend',
          newPagination.outerHTML
        );

        // 新しいページネーションを監視開始
        const nextPagination = getPagination();
        if (hasNextPage()) {
          if (nextPagination) observer.observe(nextPagination);
        } else {
          if (nextPagination) nextPagination.remove();

          // 追加で読み込むページがなくなったら、売り切れ商品を表示する
          showUnavailableProducts();

          // LazyLoadの再実行
          window.preloadImages(autopagerizeElement);
        }
      })
      .catch(error => {
        console.error('Error loading next page:', error);
      });
  }

  // ========== 実行部分 ==========

  // Observerで監視を開始
  const pagination = getPagination();
  if (pagination) {
    observer.observe(pagination);
  } else {
    // ページネーションがない場合、売り切れ商品を表示する
    showUnavailableProducts();
    // LazyLoadの再実行
    window.preloadImages(autopagerizeElement);
  }
});
